import { chakra } from '@stockx/ui';

export const SectionContainer = chakra('div', {
  baseStyle: {
    display: 'flex',
    flexDirection: 'column',
  },
});

export const Section = chakra('div', {
  baseStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: 'neutral.black',
    fontSize: 'lg',
    fontWeight: '500',
    padding: '8px 0px 8px 16px',
  },
});

// Rendering span here as a "wrapper" around the
// SwitcherLink component bc when you pass "as" prop
// chakra factory coerces the DOM element to <BROWSE> or <PRODUCT>
// and we don't want that.
export const SectionTitleLink = chakra('span', {
  baseStyle: {
    color: 'neutral.black',
    width: '100%',
    borderTop: 'none',
    paddingTop: 0,

    '&.my-account': {
      paddingTop: 5,
      borderTopWidth: '1px',
      borderTopStyle: 'solid',
      borderTopColor: 'neutral.300',
    },
    '&.localization-title': {
      width: 'calc(100% - 99px)',
    },
  },
});

export const BlogATag = chakra('a', {
  baseStyle: {
    color: 'neutral.black',
    width: '100%',
    borderTop: 'none',
    paddingTop: 0,

    '&.localization-title': {
      width: 'calc(100% - 99px)',
    },
  },
});

// Rendering span here as a "wrapper" around the
// SwitcherLink component bc when you pass "as" prop
// chakra factory coerces the DOM element to <BROWSE> or <PRODUCT>
// and we don't want that.
export const SectionSubTitleLink = chakra('span', {
  baseStyle: {
    color: 'green.700',
    fontSize: 'sm',
    fontWeight: 700,
    marginRight: 4,
    _hover: {
      color: 'green.700',
    },
    _focus: {
      color: 'green.700',
    },
  },
});

export const SubSectionContainer = chakra('div', {
  baseStyle: {
    backgroundColor: 'neutral.100',
    width: '100%',
  },
});

export const SubSection = chakra('div', {
  baseStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

export const SubSectionTitle = chakra('div', {
  baseStyle: {
    fontSize: 'md',
    fontWeight: 500,
    padding: '8px 0px 8px 16px',
  },
});

// Rendering span here as a "wrapper" around the
// SwitcherLink component bc when you pass "as" prop
// chakra factory coerces the DOM element to <BROWSE> or <PRODUCT>
// and we don't want that.
export const SubSectionTitleLink = chakra('span', {
  baseStyle: {
    color: 'neutral.black',
    fontSize: 'md',
    fontWeight: 500,
    padding: '8px 0px 8px 16px',
  },
});

export const Chevron = chakra('div', {
  baseStyle: {
    color: 'neutral.black',
    fontWeight: 500,
    marginRight: 4,
  },
});
